import { Box, BoxProps, ColorOptions, convertHexToRGBA, Spacer, TextProps } from '@jfs/ui-new'
import { useRoute } from '@react-navigation/native'
import { useCallback, useRef, useState } from 'react'
import { ScrollView } from 'react-native'
import { useStores } from '../../../../data/store'
import { isIFrame } from '../../../../utils'
import { windowConfig } from '../../../../utils/constants'
import { MobileProcessing } from '../../../PaymentProcesseing/MobileProcessing'
import { MetaDataTags } from '../../comps/MetaDataTags'
import { getPaymentObject } from '../../comps/PaymentProcessingHelper'
import { ProgressIndicator } from '../../comps/ProgressIndicator'
import { SelectedEmiPlanInfo } from '../SelectEmiPlans/SelectedEmiPlanInfo'
import { EmiListModel } from './EmiListModal'

export const ProceedToPayment = () => {
  const { theme, amountPayable, payerMobile, eligibilityResponseID, subType, addCardPaymentMethod, uniqueWindowId } =
    useStores((root) => ({
      theme: root.config.merchantTheme,
      amountPayable: root.jioPayFinanceHub.amountPayable,
      payerMobile: root?.jioPayFinanceHub?.mobileNo,
      eligibilityResponseID: root.jioPayFinanceHub?.eligibilityResponseID,
      subType: root.jioPayFinanceHub?.subType,
      addCardPaymentMethod: root.transaction.addPaymentMethod,
      uniqueWindowId: root.config.uniqueWindowId,
    }))
  const { REACT_APP_URL = '', REACT_APP_ENDPOINT = '' } = process.env
  const [showPaymentProcessModal, setShowPaymentProcessModal] = useState(false)

  const [showEmiList, setShowEmiList] = useState(false)
  const route: any = useRoute()

  const emiList = route.params.emiList
  const [selectedEMIData, setSelectedEMIData] = useState(route.params.selectedEMIData)
  const userMetaData = route.params?.metaData
  const style = styleFunc(theme)
  const loadProcessingScreen = useCallback(() => {
    const loaderUrl = REACT_APP_ENDPOINT
      ? `${REACT_APP_URL}/${REACT_APP_ENDPOINT}/loader.html`
      : `${REACT_APP_URL}/loader.html`
    if (!isIFrame()) {
      window.currentChild = window
    } else {
      try {
        window.currentChild = window.open(loaderUrl, `jiopayWindow-${uniqueWindowId}`, windowConfig)
        window.currentChild?.focus()
      } catch (e) {
        window.parent.postMessage(
          {
            txnId: 0,
            intentId: 897,
            status: 'error',
            message: 'Not supported direct payment in inframe checkout',
          },
          '*',
        )
      }
    }
    setShowPaymentProcessModal(true)
  }, [REACT_APP_ENDPOINT, REACT_APP_URL, uniqueWindowId])

  const confirmMetaData = useRef({})

  const handleCardPayment = useCallback(
    (data: any) => {
      confirmMetaData.current = { mobile: payerMobile, ...confirmMetaData.current, ...data }
      const paymentMode = getPaymentObject({
        data: { mobile: payerMobile, ...confirmMetaData.current, ...data },
        payerMobile,
        subType,
        eligibilityResponseID,
        selectedEMIData,
      })
      addCardPaymentMethod(paymentMode)
      loadProcessingScreen()
    },
    [addCardPaymentMethod, eligibilityResponseID, loadProcessingScreen, payerMobile, selectedEMIData, subType],
  )

  const getMetaData = useCallback(() => {
    const copyMetaData = JSON.parse(JSON.stringify(selectedEMIData?.metadata))
    userMetaData &&
      Object.keys(userMetaData).map((key) => {
        if (copyMetaData?.find((item: any, index: any) => item?.name === key)) {
          selectedEMIData.metadata = selectedEMIData?.metadata.filter((item: any) => item.name !== key)
          confirmMetaData.current = { ...confirmMetaData.current, [key]: userMetaData[key] }
        }
      })
    return selectedEMIData.metadata
  }, [selectedEMIData, userMetaData])

  return (
    <Box {...style.container} backgroundColor={theme?.bodyBgColor as ColorOptions}>
      <Box ph={32} pb={12}>
        <ProgressIndicator data={['Eligibility', 'EMI Plan', 'Payment']} currentStep={3} />
      </Box>

      <ScrollView
        keyboardShouldPersistTaps="always"
        style={{
          flexGrow: 1,
          backgroundColor: theme?.bodyBgColor as ColorOptions,
          paddingTop: 20,
        }}>
        <>
          <SelectedEmiPlanInfo
            amountPayable={amountPayable}
            bankName={selectedEMIData?.bankName}
            theme={theme}
            emiData={selectedEMIData}
            changeEmiPlan={() => {
              setShowEmiList(true)
            }}
          />
          <Spacer size={18} />
          <MetaDataTags
            metadata={getMetaData()}
            amount={amountPayable}
            title={'Proceed to Pay'}
            onSubmit={(data: any) => {
              handleCardPayment(data)
            }}
            headerText={'Enter your required details to authenticate your EMI transaction.'}
          />
        </>
        <Spacer size={24} />
        <EmiListModel
          show={showEmiList}
          onDismiss={() => {
            setShowEmiList(false)
          }}
          theme={theme}
          emiPlansData={emiList}
          amountPayable={amountPayable}
          onPlanSelected={(item: any) => {
            setSelectedEMIData(item)
            setShowEmiList(false)
          }}
        />
      </ScrollView>
      {showPaymentProcessModal && (
        <MobileProcessing setShow={setShowPaymentProcessModal} show={showPaymentProcessModal} />
      )}
    </Box>
  )
}
const styleFunc = (theme: any) => ({
  container: {
    pv: 24,
    flexDirection: 'column',
    height: '100%',
    flex: 1,
  } as BoxProps,
  header: {
    fontSize: 12,
    color: convertHexToRGBA(theme?.bodyTextColor, 50) as any,
    fontFamily: 'jiotype-Medium',
    lineHeight: 18,
  } as TextProps,
})
